"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@emotion/react");
exports.default = (0, react_1.css) `
    position: fixed;
    left: 0;
    right: 0;
    width: -moz-fit-content;
    width: -webkit-fit-content;
    width: fit-content;
    height: -moz-fit-content;
    height: -webkit-fit-content;
    height: fit-content;
    margin: auto;
    padding: 1em;
    background: transparent;
    display: block;

    &:not([open]) {
        display: none;
    }

    &.image-modal__dialog_isPolyfill {
        background: rgba(50, 50, 50, 0.4);
        position: fixed !important;
        top: 50% !important;
        transform: translate(0, -50%) !important;
    }

    & + .backdrop {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
    }

    &::backdrop {
        background: rgba(50, 50, 50, 0.4);
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
    }

    ._dialog_overlay {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
    }

    &[open] {
        inset-block-start: 0px;
        inset-block-end: 0px;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        outline: none;
        border: none;
        margin: 0px;
    }

    .image-modal__wrapper {
        background-color: white;
        border-radius: 4px;
        position: relative;
        max-height: 80vh;
        max-width: 80vw;
        overflow: auto;
        overflow-x: hidden;
        position: relative;
    }
    .image-modal__wrapper_isPolyfill {
        background-color: transparent;
    }

    .image-modal__image {
        max-height: 90vh;
        max-width: 80vw;
        border-radius: 4px;
        display: block;
    }

    .image-modal__icons {
        position: absolute;
        top: 20px;
        right: 20px;
        display: flex;
        align-items: center;
        gap:8px;
    }

    .image-modal__image_zoom {
        max-height: none;
        max-width: none;
    }
    .image-modal__wrapper_zoom {
        overflow-x: visible;
    }

    .image-modal__image_isVertical {
        max-height: none;
    }

    @media (max-width: 640px) {
        .image-modal__icons {
            top: 12px;
            right: 12px;
        }
    }
`;
